/* Turapura cookie copy — preserves Shopify's native consent actions. */
(function () {
  'use strict';

  var observer;
  var scheduled = false;

  function isFrench() {
    return (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
  }

  function setButtonText(root, selector, text) {
    var button = root.querySelector(selector);
    if (button && button.textContent.trim() !== text) {
      button.textContent = text;
      button.setAttribute('aria-label', text);
    }
  }

  function applyCopy() {
    scheduled = false;
    if (!isFrench()) return;

    var banner = document.querySelector('#shopify-pc__banner, .shopify-pc__banner__dialog');
    if (!banner || banner.dataset.turapuraCopyReady === 'true') return;

    var heading = banner.querySelector('.shopify-pc__banner__heading, [class*="heading"], h2');
    if (heading) heading.textContent = 'Votre confidentialité, votre choix';

    var paragraph = banner.querySelector('.shopify-pc__banner__text, [class*="body"] p, p');
    if (paragraph) {
      paragraph.textContent = 'Nous utilisons des cookies indispensables au fonctionnement du site. Avec votre accord, d’autres cookies nous aident à mesurer l’audience et à vous proposer des contenus adaptés. Vous pouvez accepter, refuser ou personnaliser vos choix. ';

      var link = document.createElement('a');
      var rootPath = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      link.href = rootPath + 'policies/privacy-policy';
      link.textContent = 'En savoir plus';
      paragraph.appendChild(link);
      paragraph.appendChild(document.createTextNode('.'));
    }

    setButtonText(banner, '#shopify-pc__banner__btn-accept', 'Tout accepter');
    setButtonText(banner, '#shopify-pc__banner__btn-decline', 'Tout refuser');
    setButtonText(banner, '#shopify-pc__banner__btn-manage-prefs', 'Personnaliser');

    banner.dataset.turapuraCopyReady = 'true';
  }

  function scheduleApply() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(applyCopy);
  }

  function init() {
    applyCopy();
    observer = new MutationObserver(scheduleApply);
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () {
      if (observer) observer.disconnect();
    }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();